// extracted by mini-css-extract-plugin
export default {"productsAndFiltersContainer":"ProductsAndFilters_productsAndFiltersContainer__8xY-x","autoGrid":"ProductsAndFilters_autoGrid__KSSkn"};